import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import config from "@/config";
import DownloadLink from "@/components/DownloadLink";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* Header */}
      <motion.header
        className="sticky top-0 z-50 flex items-center justify-between bg-background-50/80 px-4 py-3 backdrop-blur-md"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: [0.25, 0.4, 0.25, 1] }}
      >
        <Link
          to="/"
          className="flex items-center gap-1.5 text-sm text-foreground-400 transition-colors hover:text-foreground-200 whitespace-nowrap cursor-pointer"
        >
          <span className="flex h-7 w-7 items-center justify-center">
            <i className="ri-arrow-left-line text-lg" />
          </span>
          <span className="hidden sm:inline">トップページ</span>
        </Link>
        <span className="text-sm font-bold text-foreground-100">利用規約</span>
        <div className="w-20" />
      </motion.header>

      {/* Content */}
      <main className="mx-auto max-w-2xl px-4 py-8 pb-32 sm:px-6 sm:py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h1 className="font-heading text-2xl font-bold text-foreground-100 sm:text-3xl">
            利用規約
          </h1>
          <p className="mt-2 text-sm text-foreground-400">
            最終更新日：2025年1月1日
          </p>

          <div className="mt-8 space-y-8 text-sm leading-relaxed text-foreground-300 sm:text-base">
            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第1条（適用）
              </h2>
              <p>
                本利用規約（以下「本規約」といいます）は、{config.siteTitle}（以下「当社」といいます）が提供するアプリケーション「{config.siteTitle}」および関連サービス（以下「本サービス」といいます）の利用条件を定めるものです。ユーザーの皆さま（以下「ユーザー」といいます）には、本規約に従って本サービスをご利用いただきます。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第2条（年齢制限）
              </h2>
              <p>
                本サービスは18歳以上の方を対象としております。18歳未満の方は本サービスを利用できません。当社は、ユーザーが18歳以上であることを確認するため、年齢確認を行う場合があります。虚偽の年齢情報を提供した場合、アカウントは即時停止されます。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第3条（アカウント登録）
              </h2>
              <ol className="list-decimal space-y-2 pl-5">
                <li>
                  ユーザーは、本サービスの利用に際して、正確かつ最新の情報を提供するものとします。
                </li>
                <li>
                  ユーザーは、自己のアカウント情報（パスワードを含む）を厳重に管理する責任を負います。
                </li>
                <li>
                  一人のユーザーが複数のアカウントを保有することは禁止します。
                </li>
                <li>
                  当社は、登録情報に虚偽があった場合、または本規約に違反した場合、事前の通知なくアカウントを停止または削除することができます。
                </li>
              </ol>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第4条（禁止事項）
              </h2>
              <p className="mb-2">ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません：</p>
              <ol className="list-decimal space-y-2 pl-5">
                <li>法令または公序良俗に違反する行為</li>
                <li>犯罪行為に関連する行為</li>
                <li>
                  他のユーザーまたは第三者の知的財産権、肖像権、プライバシー権、名誉その他の権利または利益を侵害する行為
                </li>
                <li>
                  他のユーザーに対する嫌がらせ、誹謗中傷、ストーカー行為、または脅迫行為
                </li>
                <li>
                  営利目的での利用（当社が事前に承諾した場合を除く）
                </li>
                <li>本サービスの運営を妨害する行為</li>
                <li>不正アクセス、またはこれを試みる行為</li>
                <li>
                  他のユーザーの個人情報を収集または蓄積する行為
                </li>
                <li>本サービスに不具合を生じさせる行為</li>
                <li>当社の信用を毀損する行為</li>
              </ol>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第5条（利用料金）
              </h2>
              <p>
                本サービスの基本機能は無料でご利用いただけます。一部のプレミアム機能は有料となり、アプリ内購入を通じてご利用いただけます。料金および支払い方法の詳細は、アプリ内に表示されます。購入が完了した後の返金は、法令に基づく場合を除き、原則としてお受けできません。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第6条（知的財産権）
              </h2>
              <p>
                本サービスに関する著作権、商標権、その他すべての知的財産権は、当社または当社にライセンスを許諾している者に帰属します。ユーザーは、当社の事前の書面による承諾なく、本サービスのコンテンツを複製、改変、転載、配布することはできません。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第7条（免責事項）
              </h2>
              <ol className="list-decimal space-y-2 pl-5">
                <li>
                  当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます）がないことを明示的にも黙示的にも保証しておりません。
                </li>
                <li>
                  当社は、本サービスに起因してユーザーに生じたあらゆる損害について、当社の故意または重過失による場合を除き、一切の責任を負いません。
                </li>
                <li>
                  ユーザー間のトラブルについては、当社は一切の責任を負わず、当事者間で解決していただきます。
                </li>
              </ol>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第8条（サービスの変更・停止）
              </h2>
              <p>
                当社は、以下の場合には、事前の通知なく本サービスの全部または一部を停止または中断することができるものとします：
              </p>
              <ol className="mt-2 list-decimal space-y-1 pl-5">
                <li>本サービスにかかるシステムの点検または保守作業を行う場合</li>
                <li>
                  地震、落雷、火災、停電、天災などの不可抗力により本サービスの提供が困難となった場合
                </li>
                <li>その他、当社が停止または中断を必要と合理的に判断した場合</li>
              </ol>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第9条（規約の変更）
              </h2>
              <p>
                当社は、必要と判断した場合には、ユーザーに通知することなく本規約を変更することができるものとします。変更後の規約は、本サービス上に表示された時点から効力を生じるものとします。変更後も本サービスを継続して利用する場合、ユーザーは変更後の規約に同意したものとみなします。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                第10条（準拠法・管轄裁判所）
              </h2>
              <p>
                本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して生じた紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </p>
            </section>

            <section>
              <h2 className="mb-3 font-heading text-lg font-bold text-foreground-100">
                お問い合わせ
              </h2>
              <p>
                本規約に関するお問い合わせは、以下のメールアドレスまでご連絡ください：
              </p>
              <p className="mt-1 text-primary-400">{config.siteSupport}</p>
            </section>
          </div>
        </motion.div>
      </main>

      {/* Fixed bottom CTA */}
      <motion.div
        className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200/50 bg-background-50/95 px-4 py-3 backdrop-blur-md"
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.4, ease: [0.25, 0.4, 0.25, 1] }}
      >
        <div className="mx-auto max-w-2xl">
          <DownloadLink
            downloadType="button"
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-500 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line text-3xl" />
            アプリを今すぐダウンロード
            <br/>
            無料で始められます
          </DownloadLink>
        </div>
      </motion.div>
    </div>
  );
}